import React from 'react';
import PropTypes from 'prop-types';
import {PieChart, Pie, Cell, Label} from 'recharts';
import {formatMoney} from 'core/utils';
import styles from './styles.css';

const CreditChartV2 = ({creditSummary}) => {
    const data = [
        {name: 'available', value: creditSummary.available},
        {name: 'consumed', value: creditSummary.consumed},
    ];
    const colors = ['#FFD100', '#A29A9C'];

    return (
        <PieChart width={300} height={300}>
            <Pie
                data={data}
                outerRadius={145}
                innerRadius={130}
                dataKey='value'>
                <Label value='Disponible' position='center' className={styles.labelTop} />
                <Label
                    value={`${Math.trunc(creditSummary.availablePercentage)}%`}
                    position='center'
                    className={styles.labelCenter} />
                <Label
                    value={formatMoney(creditSummary, 'available')}
                    position='center'
                    className={styles.labelBottom} />
                {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                ))}
            </Pie>
        </PieChart>
    );
};

CreditChartV2.propTypes = {
    creditSummary: PropTypes.object.isRequired,
};

export default CreditChartV2;



// WEBPACK FOOTER //
// ./components/credit-chart-v2/index.js